import { Component, HostListener } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { PlayService } from '../play/play.service';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { ActivatedRoute, Router } from '@angular/router';
import { WpService } from 'src/app/services/wp.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent extends AppComponent {

  public screenHeight: number;
  public screenWidth: number;
  public logoHeight: number;
  public orientationTest: any;

  public options : AnimationOptions = {
    path: 'assets/logo-new.json',
  };

  constructor(
    public playIntroService: PlayService,
    public router: Router,
    private route: ActivatedRoute,
    private wpService: WpService,
    private userService: UserService
  ) {
    super();
    this.setLogoContainerWidth();
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    const nonce = this.route.snapshot.queryParamMap.get('nonce');
    console.log('Injected nonce:', nonce);
    this.wpService.setNonce(nonce);

    /*Maybe delete in the future*/
    this.wpService.loadCurrentUser().subscribe((user) => {

      let first_name = "";
      let last_name = "";
      let name = "";
      let email = "";

      if (user && user.hasOwnProperty('name') && typeof user.name === 'string' && user.name.split(' ').length > 1) {
        name = user.name;
        first_name = user.name.split(' ')[0];
        last_name = user.name.split(' ')[1];
      } else if (user && user.hasOwnProperty('name') && typeof user.name === 'string') {
        name = user.name;
        first_name = user.name;
      }

      this.userService.setUser({
        firstName: first_name,
        lastName: last_name,
        name: name,
        email: email
      });

      console.log('Current user:', this.userService.user);
    });
  }

  ngOnInit(){
    // this.defineOrientation();
    this.playIntroService.loadGameSounds();
  }

  public defineOrientation(){
    const orientation = window.innerWidth/window.innerHeight < 0.7 ? "portrait" : "landscape";
    // console.log(window.innerWidth);
    // console.log(window.innerHeight)
    console.log(window.innerWidth/window.innerHeight);
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event?): void {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    // console.log(`screenWidth: `, this.screenWidth);
    // this.defineOrientation();
  }

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    // this.defineOrientation();
  }

  public setLogoContainerWidth(): void{
    this.logoHeight = window.innerWidth*0.5635;
  }

  animationCreated(animationItem: AnimationItem): void {
    // console.log(animationItem);
  }

  public buttonClick(route:string): void {
    const [path, queryParams] = route.split('?');
    
    const queryParamsObject = {};
    if (queryParams) {
      const params = queryParams.split('&');
      params.forEach(param => {
        const [key, value] = param.split('=');
        queryParamsObject[key] = value;
      });
    }
    
    // button click sound trigger
    this.router.navigate([path], { queryParams: queryParamsObject });
    this.playIntroService.triggerSound('button-click');
  }
}